import { createFileRoute } from "@tanstack/react-router";
import { legacyRedirectTo } from "@/lib/legacy-redirect";

// Legacy URL /team → redirect to /app/team.
export const Route = createFileRoute("/team/")({
  beforeLoad: legacyRedirectTo("/app/team"),
  component: () => null,
});
